import React, { useEffect, useState } from 'react';
import Footer from '../../Components/Footer/Footer';
import Header from '../../Components/Header/Header';
import ProfileTab from '../../Components/Profile/ProfileTabs';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useDispatch, useSelector } from 'react-redux';
import { GetAllCategories, GetUserCategories, userInterestApi } from '../../Redux/Auth/Auth_Action';
import { showLoader } from '../../Redux/services/Loader';
import { toast } from 'react-toastify';

const MyInterests = () => {
    const reduxUser = useSelector((state) => state.Auth.user);
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch();
    const handleClickOpen = () => {
        setOpen(true);
    };
    const [interests, setInterests] = useState({ interestsData: [] })
    const [postInterests, setPostInterests] = useState([]);
    const [singleUserInterest, setSingleUserInterest] = useState();

    // console.log('26', typeof (singleUserInterest[1]));
    // console.log('post interest', postInterests);
    // console.log('interest', interests.interestsData);

    const handleClose = () => {
        setOpen(false);
    };

    // new formate starts

    const quantity = 3;

    // new formate ends

    const SaveFirsttimeCategory = () => {
        if (postInterests.length > quantity) {
            showCategoryFunc();
            toast.error(`You can only select ${quantity} interest category`);
        } else {
            dispatch(userInterestApi(postInterests, reduxUser.id))
                .then((res) => {
                    // console.log(res);
                    showLoader("none");
                })
                .catch((e) => {
                    console.log(e);
                    showLoader("none");
                })
        }
    }

    const IntrestFunction = () => {
        dispatch(GetAllCategories())
            .then((res) => {
                // console.log("GetAllCategories",res.data.response.data.data);
                setInterests({ ...interests, interestsData: res.data.response.data.data });
                showLoader("none");
            })
            .catch((e) => {
                console.log(e);
                showLoader("none");
                toast.error("Network Error");
            })
    }

    const SelectItem = (id) => {
        if (postInterests?.includes(id) === false) {
            setPostInterests((oldVal) => {
                return [...oldVal, id];
            });
        } else {
            setPostInterests((oldVal) => {
                let filtarr = postInterests?.filter((item, index) => {
                    return item !== id;
                })
                return [...filtarr];
            })
        }
    }

    // console.log(postInterests);


    const showCategoryFunc = () => {
        dispatch(GetUserCategories(reduxUser.id))
            .then((res) => {
                showLoader("none");
                setSingleUserInterest(JSON.parse(res.data.response.data.category));
                setPostInterests(JSON.parse(res.data.response.data.category));
                // console.log('asssd', res.data.response);
            })
            .catch((e) => {
                showLoader("none");
                console.log("error", e)
                toast.error("Network Error");
            })
    }

    useEffect(() => {
        IntrestFunction();
        showCategoryFunc();
    }, [])



    return (
        <div className='MyInterests'>
            <section className='profile my_subscription'>
                <Header />
                <div className='container px-4'>
                    <div className='row'>
                        <div className='col-lg-12 text-center'>
                            <p className='f-pop-bold f-43 mb-5 mt-3'>My Profile</p>
                        </div>
                        <div className='col-lg-4'>
                            <ProfileTab />
                        </div>
                        <div className='col-lg-8 px-5 mb-5 res-pxx'>
                            <div className='row'>
                                <div className='col-lg-12'>
                                    <p className='f-pop-bold f-30 mb-4'>Interests</p>
                                    <p className='f-mon-semibold f-20 mb-4 mt-4'>Edit Your Interests Here</p>
                                </div>
                                <div className='col-lg-8'>
                                    {interests?.interestsData.map((item, index) => {
                                        return (
                                            <div key={index} className='intrest_div'>
                                                <span
                                                    className='clr-e0 f-mon-bold'>{item.title}</span>
                                                <input
                                                    type="checkbox"
                                                    checked={postInterests.includes(item?.id)}
                                                    onChange={selected => SelectItem(item.id)}
                                                    className='mt-1 ml-3' />
                                            </div>
                                        )
                                    })}
                                    <button className='btn btn-light btn-pink-now f-mon-bold' onClick={SaveFirsttimeCategory} autoFocus>
                                        Submit
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
};

export default MyInterests;